import type { Activity } from '@/types/api';
import { ACTIVITY } from '@/utils/labels';
import { useSegments } from '@/utils/use-segments';

import { SegmentChip } from './segment-chip';

/**
 * A casino's activity as a segment tag. It takes the colour of the segment with the
 * same name (Dormant, Active, High velocity), so it matches the Segments page and
 * follows the colour the team picks there; grey when no segment has that name.
 */
const ActivityBadge = ({ activity }: { activity: Activity }) => {
  const { byName } = useSegments();
  const { label, hint } = ACTIVITY[activity];
  return <SegmentChip name={label} color={byName(label)?.color} title={hint} />;
};

export default ActivityBadge;
